import { render, staticRenderFns } from "./TCLAOrphans.vue?vue&type=template&id=f65fcbb4&scoped=true"
import script from "./TCLAOrphans.vue?vue&type=script&lang=js"
export * from "./TCLAOrphans.vue?vue&type=script&lang=js"
import style0 from "./TCLAOrphans.vue?vue&type=style&index=0&id=f65fcbb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65fcbb4",
  null
  
)

export default component.exports